import { Suspense, ComponentType } from 'react';
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //
const Loadable = <P extends object>(Component: ComponentType<P>) => (props: P) => (
  <Suspense fallback={<Loader height={4} width={23}  />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;